import { render, staticRenderFns } from "./MemberDetail2s.vue?vue&type=template&id=2d31b5f7&scoped=true"
import script from "./MemberDetail2s.vue?vue&type=script&lang=js"
export * from "./MemberDetail2s.vue?vue&type=script&lang=js"
import style0 from "./MemberDetail2s.vue?vue&type=style&index=0&id=2d31b5f7&prod&lang=less&scoped=true"
import style1 from "./MemberDetail2s.vue?vue&type=style&index=1&id=2d31b5f7&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d31b5f7",
  null
  
)

export default component.exports